import van from "vanjs-core";

const {div, span, small} = van.tags;


// Maly tag z footeru
export const SmallTagWithDescriptions = (descriptionCs, descriptionEn, stateVar, unit='') => {
    return (
        div({class: "d-flex flex-column align-items-center ms-5-fluid"},
            span({class: "sm-label text-white"}, descriptionEn),
            span({class: "sm-label text-light-blue mt-1"}, descriptionCs),
            span({class: "bg-white pl-tag text-dark-blue sm-tag-padding sm-tag-border sm-tag-text mt-2"},
                () => stateVar.val,
                small(unit),
            ),
        )
    );
};